// Constructor functions

class Hangman {
    constructor(word, tries) {
    this.word = word.toLowerCase().split('')
    this.tries = tries
    this.guessedLetters = [],
    this.status = 'playing'
    }
    currentStatus() {
        const finished = this.word.every((letter) => this.guessedLetters.includes(letter) || letter === ' ')

    if (this.tries === 0) {
      this.status = 'failed'
    } else if (finished) {
        this.status = 'finished'
    } else {
        this.status = 'playing'
    }
    }
    get statusMessage() {
        if (this.status === 'playing') {
            return `Guesses left: ${this.tries}`
        } else if (this.status === 'failed') {
            return `Nice try! The word was "${this.word.join('')}".`
        } else {
          return  'Great work! You guessed the word.'
        }
    }
    get puzzle() {
        let puzzle = ''

    this.word.forEach((letter) => {
        if (this.guessedLetters.includes(letter) || letter === ' ') {
           puzzle += letter 
        } else {
            puzzle += '*'
        }
    })

    return puzzle
    }
    makeGuess(guess) {
        guess = guess.toLowerCase()  
        //  document.querySelector('#already-guessed').value = this.guessedLetters.push(guess)
        const isUnique = !this.guessedLetters.includes(guess)
        const isBadGuess = !this.word.includes(guess)
    
    if (this.status !== 'playing') {
        return
    }
        if (isUnique) {
            
            this.guessedLetters.push(guess)
        }
        if (isUnique && isBadGuess) {
            this.tries--
        }
    this.currentStatus()
    }

}

export { Hangman as default }







